/* eslint-disable @typescript-eslint/indent */
import { AbstractControl, ValidatorFn } from "@angular/forms";
import * as moment from "moment";
import { VALUE } from "../constants/values";

export const isSameOrAfter =
  (date = VALUE.DEFAULT_MIN_DATE): ValidatorFn =>
  (control: AbstractControl) => {
    const dateMoment = moment(date);
    const toCompare = moment(control.value);
    return toCompare.isSameOrAfter(dateMoment) ? null : { minDate: "InvalidDate" };
  };

export const isSameOrBefore =
  (date = VALUE.DEFAULT_MIN_DATE): ValidatorFn =>
  (control: AbstractControl) => {
    const dateMoment = moment(date);
    const toCompare = moment(control.value);
    return toCompare.isSameOrBefore(dateMoment) ? null : { maxDate: "InvalidDate" };
  };

export const isBefore =
  (date: Date | string): ValidatorFn =>
  (control: AbstractControl) => {
    const dateMoment = moment(date);
    const toCompare = moment(control.value);
    return toCompare.isBefore(dateMoment) ? null : { maxDate: "InvalidDate" };
  };

export const isNotEqual =
  (value: string): ValidatorFn =>
  (control: AbstractControl) =>
    value !== control.value ? null : { same: "invalid" };

export const arePasswordsEquals = (): ValidatorFn => (control: AbstractControl) =>
  control?.parent?.value?.password === control.value ? null : { passwordRepeat: "invalid" };
